import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, Children } from "react";
import PropTypes from "prop-types";
import { Footer } from "../footer/footer.es.js";
import { Header } from "../header/header.es.js";
import { ContainerOuter, ContainerInner } from "./container.styles.es.js";
const propTypes = {
  as: PropTypes.elementType,
  borderRadiusPlacement: PropTypes.oneOf([
    "all",
    "bottom",
    "bottomLeft",
    "bottomRight",
    "left",
    "right",
    "topLeft",
    "topRight"
  ]),
  borderRadiusSize: PropTypes.oneOf(["none", "small", "large"]),
  children: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(["horizontal", "vertical"]),
  shadow: PropTypes.bool
};
const defaultProps = {
  as: void 0,
  borderRadiusPlacement: "all",
  borderRadiusSize: "none",
  direction: "horizontal",
  shadow: false
};
const Container = forwardRef(
  ({
    as,
    borderRadiusPlacement,
    borderRadiusSize,
    children: rawChildren,
    direction,
    shadow
  }, ref) => {
    const children = Children.toArray(rawChildren);
    const header = children.find((child) => child.type === Header);
    const footer = children.find((child) => child.type === Footer);
    return /* @__PURE__ */ jsxs(
      ContainerOuter,
      {
        ref,
        as,
        $borderRadiusPlacement: borderRadiusPlacement,
        $borderRadiusSize: borderRadiusSize,
        $direction: direction,
        $shadow: shadow,
        children: [
          header,
          /* @__PURE__ */ jsx(
            ContainerInner,
            {
              $direction: direction,
              $withFooter: Boolean(footer),
              $withHeader: Boolean(header),
              children: children.filter(
                (child) => child.type !== Header && child.type !== Footer
              )
            }
          ),
          footer
        ]
      }
    );
  }
);
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
export {
  Container
};
